/**
 *
 * BranchLeaveForm
 *
 */

import { RootState } from 'controller/types';
import { Checkbox } from 'core/components/Checkbox';
import { SubmitButton } from 'core/components/SetupComponents/SubmitButton';
import { Input } from 'core/components/Input';
import { TextArea } from 'core/components/TextArea';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';

import { BranchLeave } from 'core/utils/types/modules/org';
import { useBranchSetupSlice } from 'features/BranchSetup/slice';
import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import styled from 'styled-components/macro';
import { isValidInput } from 'core/utils/constants';

interface Props {
  values?: BranchLeave;
  action?: string;
  onNext?: () => void;
}

export const BranchLeaveForm = memo((props: Props) => {
  const authData = useAuth();
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.branchSetup);
  const params = useParams();
  const { actions } = useBranchSetupSlice();
  const [checked, setchecked] = React.useState<boolean>(false);
  const [values, setvalues] = React.useState<BranchLeave>({
    NAME: '',
    DESCRIPTION: '',
    LEAVE_COUNT: 1,
    IS_PAID_LEAVE: false,
  } as BranchLeave);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setvalues({
      ...values,
      [name]: value,
    });
    setIsDirty(true);
  };
  const [isDirty, setIsDirty] = React.useState<boolean>(false);

  const onSubmit = e => {
    e.preventDefault();

    dispatch(
      actions.createBranchSetupStart({
        URL: params?.url as string || 'staffLeaveType',
        data: {
          ...values,
          BRANCH_ID: authData?.BRANCH_ID as number,
          IS_PAID_LEAVE: checked,
        },
        action: props.action || 'save',
        message: props.action
          ? 'Updated Successfully!'
          : 'Created Successfully!',
      }),
    );
    setIsDirty(false);
  };

  React.useEffect(() => {
    if (props.values?.STAFF_LEAVE_TYPE_ID) {
      setvalues({ ...props.values } as BranchLeave);
      if (props.values.IS_PAID_LEAVE) setchecked(true);
    }
  }, [props.values?.STAFF_LEAVE_TYPE_ID]);

  React.useEffect(() => {
    if (state?.navigate){
      props?.onNext && props?.onNext();
      dispatch(actions.setNavigate(false));
    }
  },[state?.navigate])

  return (
    <Div className="w-full h-full" onSubmit={onSubmit}>
      <Input
        name="NAME"
        placeholder="Leave Title"
        onChange={handleInputChange}
        value={values.NAME}
        width="w-[60%] mx-0"
        label="Title"
        required
        maxLength={45}
      />
      <TextArea
        value={values.DESCRIPTION}
        onChange={e => {
          setvalues({
            ...values,
            DESCRIPTION: e.target.value,
          });
          setIsDirty(true);
        }}
        placeholder="Description"
        label="Description"
        height="h-[15vh]"
        margin="mt-[2vh]"
        required
        maxLength={200}
      />
      <div className="grid grid-cols-2 gap-[2vw]">
        <Input
          type="number"
          name="LEAVE_COUNT"
          placeholder="Enter the number of leaves"
          onChange={handleInputChange}
          value={values.LEAVE_COUNT}
          label={'Leave Count'}
          min="1"
          message="Leave count should be atleast 1"
          required
        />
      </div>
      <div className="w-max mt-[2vh] flex items-center">
        <Checkbox
          bordercolor="border-neutral-50"
          width="w-[1.5vw] h-[1.5vw] mr-[0.5vw] text-sm"
          checked={checked}
          setChecked={setchecked}
        />
        <p className="text-lg w-fit min-w-[7vw]">Is Paid Leave?</p>
      </div>
      <div className='text-center'>
      <SubmitButton
        inputValidate={
          values &&
          ((values.DESCRIPTION !== undefined && !values.DESCRIPTION.length  || !isValidInput(values.DESCRIPTION)) ||
            (values.NAME !== undefined && !values.NAME.length  || !isValidInput(values.NAME, true)) ||
            !values.LEAVE_COUNT)
        }
        isDirty={isDirty}
      />
      </div>
    </Div>
  );
});

const Div = styled.form``;